import http from "../../utils/httpClient"

class brandService {
  createBrand = async (data) => {
    return await http.post("/api/Brand/CreateBrand", data)
  }

  getBrand = async (query) => {
    return await http.get("/api/Brand/GetBrand", { params: query })
  }

  getBrandDataNew = async (query) => {
    return await http.get("/api/Brand/GetBrandForCustomer", { params: query })
  }
}
export default new brandService()
